// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  TradingPair,
} from "./types";


export default __t.row({
  key: __t.string().primaryKey(),
  pairKey: __t.string().name("pair_key"),
  get pair() {
    return TradingPair;
  },
  price: __t.u128(),
  bidAmount: __t.u64().name("bid_amount"),
  askAmount: __t.u64().name("ask_amount"),
});
